// Generated by CoffeeScript 2.7.0
var Admin__PushPackagesController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import GeneratePushPackageSidebar from 'trunks/vue/admin/compositions/push_package/push_package_sidebar.js';

import PushPackagePayload from 'trunks/vue/admin/compositions/push_package/push_package_payload.js';

export default Admin__PushPackagesController = (function() {
  class Admin__PushPackagesController extends Skylark.App.BaseController {
    index() {
      return this._generatePushPackageSidebar('user', '');
    }

    show() {
      var id, push_package_container;
      this.resourceUrl = '/admin/push_packages';
      push_package_container = DomMaster.find("#push_package_container").node;
      id = this.getIds()[0];
      this._generatePushPackageSidebar('user', id);
      return new PushPackagePayload({
        el: push_package_container,
        propsData: {
          resourceUrl: `${this.resourceUrl}/${id}`
        }
      });
    }

  };

  Admin__PushPackagesController.include(GenerateMorePopover);

  Admin__PushPackagesController.include(GeneratePushPackageSidebar);

  return Admin__PushPackagesController;

}).call(this);
